import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';
import BaseSkeleton from '../BaseSkeleton';

import { KycCardSkeletonProps } from './KycCardSkeleton.types'

const KycCardSkeleton: React.FC<KycCardSkeletonProps> = ({
  className,
  strip,
  address,
}) => {

  const textContent = (textClassName='') => {
    return (
      <div className={`flex flex-column ${textClassName} `}>
        <BaseSkeleton width={100} className='mb1' />
        <BaseSkeleton width={200} />
      </div>
    )
  }

  return (
    <Card className={`relative flex flex-column p4 ${className}`} strip={strip}>
      <div className="flex flex-justify mb6">
        {textContent()}
        <Skeleton width={36} height={36} variant="circle" />
      </div>
      <div className="flex mb6">
        {textContent('width-50')}
        {textContent()}
      </div>
      {address && (<div className="flex flex-justify">
        {textContent()}
      </div>)}
    </Card>
  );
};

export default KycCardSkeleton;
export { KycCardSkeletonProps };
